import Api from "./api";
import OidcManager from "./oidcManager";

export enum MarkupAmountType {
    Currency,
    Percentage
}

export interface Markup {
    overhead: {
        text: string,
        value: number,
        type: MarkupAmountType
    },
    contingency: {
        text: string,
        value: number,
        type: MarkupAmountType
    },
    profit: {
        text: string,
        value: number,
        type: MarkupAmountType
    }
}


export class MarkupsApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {estimateId: number }): JQueryPromise<Markup> {
        return super.get("/api/markups", command);
    }

    save(command: Markup & { estimateId: number }): JQueryPromise<Markup> {
        return super.post("/api/markups", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/markups.ts